export default __webpack_public_path__ + "static/media/product-image-hover-10.a6e7b26b.jpg";